
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as healthUbP3XoUARowI0T6Iv9vVeH2RJ3IaTEBslKcFEH45w9UMeta } from "/codebuild/output/src3975238830/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/health.vue?macro=true";
import { default as _91_46_46_46slug_93oSPDxBGDSFja7qkjakXTlNDxVlF9fNRz_45IhJ7B07_45ywMeta } from "/codebuild/output/src3975238830/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/[...slug].vue?macro=true";
import { default as guidesOvw1PXfArz3szJG_yg2P3NH8aOU_4553lJq9eNhICtUHEMeta } from "/codebuild/output/src3975238830/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/[IATA]/guides.vue?macro=true";
import { default as port_45parkingIBtr1vRyJBg9TAQKEkGXrf82Vl3TElOibV4Qbj4k_45o0Meta } from "/codebuild/output/src3975238830/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/[IATA]/port-parking.vue?macro=true";
import { default as airport_45parkingZ6_mNYVkh2CEHk9UHOXZVskqevh9D4WgWd5lIS5KUnYMeta } from "/codebuild/output/src3975238830/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/[IATA]/airport-parking.vue?macro=true";
import { default as parking_45couponsoW3kXHShShtecI1gNY4RZDWZFJ8NGf8OQTvL2Wxr_7YMeta } from "/codebuild/output/src3975238830/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/[IATA]/parking-coupons.vue?macro=true";
import { default as _91result_93JFiOr0nL4ylQT_45RyrXqhdyl8xW6RsusemKzNTTLWbMAMeta } from "/codebuild/output/src3975238830/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/flight-status/[result].vue?macro=true";
import { default as airport_45shuttlesrRzxsVltnFw86wE8vHGm9JTw1yxonpQurYG52od_Kv4Meta } from "/codebuild/output/src3975238830/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/[IATA]/airport-shuttles.vue?macro=true";
import { default as _91code_93_45_91name_93_45_91IATA_933uGfxg_DXhPSwBSEHlt4g7W2LT45FLwIdf9kzgq8YHcMeta } from "/codebuild/output/src3975238830/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/hro/[code]-[name]-[IATA].vue?macro=true";
import { default as indexHjaL_Q2SpkwpMn4tWsn1_kKstQ8wdzTAYqaVfrwDJqoMeta } from "/codebuild/output/src3975238830/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/shuttles/[airport]/index.vue?macro=true";
import { default as off_45airport_45parkingw4696z3HzstgbqS1_c_rZma3cqopA84AOyvv9MR4dEoMeta } from "/codebuild/output/src3975238830/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/[IATA]/off-airport-parking.vue?macro=true";
import { default as _91code_93_45_91name_93_45_91IATA_93CshmlE8Ro2SpFoDK8Gk6LbOJzW84Jp_sGGvyoucX28cMeta } from "/codebuild/output/src3975238830/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/parking/[code]-[name]-[IATA].vue?macro=true";
import { default as _91product_93d6WJ9AbMegro_I4WvfQPCevXDBWQkU8f9Iju_45pl9nWkMeta } from "/codebuild/output/src3975238830/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/shuttles/[airport]/[product].vue?macro=true";
import { default as port_45hotels_45with_45parkingc_5LUhf4eV77CKG_6WMP667gVQS3m0c4liuALaNa_acMeta } from "/codebuild/output/src3975238830/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/[IATA]/port-hotels-with-parking.vue?macro=true";
import { default as airport_45hotels_45with_45parkingR_twpnwPaz49RV9jO4d3ywfGGd3MqUjW_45Ihr6pNBskMMeta } from "/codebuild/output/src3975238830/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/[IATA]/airport-hotels-with-parking.vue?macro=true";
import { default as _91code_93_45_91name_93_45_91IATA_93ZZGv_45tD4_45xml4CPMdMt0yH7T7lf9LBKl3TJoUsJwZ3YMeta } from "/codebuild/output/src3975238830/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/hotel-package/[code]-[name]-[IATA].vue?macro=true";
import { default as component_45stub26lPXVAan__45OGD6y1aHJsfzNHku7ypekj4o_dHoFicEMeta } from "/codebuild/output/src3975238830/src/bitbucket.org/magusa/cavu-workspaces/node_modules/.pnpm/nuxt@3.16.2_@parcel+watcher@2.5.1_@types+node@24.7.0_db0@0.3.4_eslint@9.37.0_jiti@1.21._4b8b6c88da3108ad874f2c506e8c7f7d/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stub26lPXVAan__45OGD6y1aHJsfzNHku7ypekj4o_dHoFicE } from "/codebuild/output/src3975238830/src/bitbucket.org/magusa/cavu-workspaces/node_modules/.pnpm/nuxt@3.16.2_@parcel+watcher@2.5.1_@types+node@24.7.0_db0@0.3.4_eslint@9.37.0_jiti@1.21._4b8b6c88da3108ad874f2c506e8c7f7d/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "health___en",
    path: "/health",
    component: () => import("/codebuild/output/src3975238830/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/health.vue")
  },
  {
    name: "slug___en",
    path: "/:slug(.*)*",
    component: () => import("/codebuild/output/src3975238830/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/[...slug].vue")
  },
  {
    name: "IATA-guides___en",
    path: "/:IATA()/guides",
    component: () => import("/codebuild/output/src3975238830/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/[IATA]/guides.vue")
  },
  {
    name: "IATA-port-parking___en",
    path: "/:IATA()/port-parking",
    component: () => import("/codebuild/output/src3975238830/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/[IATA]/port-parking.vue")
  },
  {
    name: "IATA-airport-parking___en",
    path: "/:IATA()/airport-parking",
    component: () => import("/codebuild/output/src3975238830/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/[IATA]/airport-parking.vue")
  },
  {
    name: "IATA-parking-coupons___en",
    path: "/:IATA()/parking-coupons",
    component: () => import("/codebuild/output/src3975238830/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/[IATA]/parking-coupons.vue")
  },
  {
    name: "flight-status-result___en",
    path: "/flight-status/:result()",
    component: () => import("/codebuild/output/src3975238830/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/flight-status/[result].vue")
  },
  {
    name: "IATA-airport-shuttles___en",
    path: "/:IATA()/airport-shuttles",
    component: () => import("/codebuild/output/src3975238830/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/[IATA]/airport-shuttles.vue")
  },
  {
    name: "hro-code-name-IATA___en",
    path: "/hro/:code()-:name()-:IATA()",
    component: () => import("/codebuild/output/src3975238830/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/hro/[code]-[name]-[IATA].vue")
  },
  {
    name: "shuttles-airport___en",
    path: "/shuttles/:airport()",
    meta: indexHjaL_Q2SpkwpMn4tWsn1_kKstQ8wdzTAYqaVfrwDJqoMeta || {},
    component: () => import("/codebuild/output/src3975238830/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/shuttles/[airport]/index.vue")
  },
  {
    name: "IATA-off-airport-parking___en",
    path: "/:IATA()/off-airport-parking",
    component: () => import("/codebuild/output/src3975238830/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/[IATA]/off-airport-parking.vue")
  },
  {
    name: "parking-code-name-IATA___en",
    path: "/parking/:code()-:name()-:IATA()",
    component: () => import("/codebuild/output/src3975238830/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/parking/[code]-[name]-[IATA].vue")
  },
  {
    name: "shuttles-airport-product___en",
    path: "/shuttles/:airport()/:product()",
    meta: _91product_93d6WJ9AbMegro_I4WvfQPCevXDBWQkU8f9Iju_45pl9nWkMeta || {},
    component: () => import("/codebuild/output/src3975238830/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/shuttles/[airport]/[product].vue")
  },
  {
    name: "IATA-port-hotels-with-parking___en",
    path: "/:IATA()/port-hotels-with-parking",
    component: () => import("/codebuild/output/src3975238830/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/[IATA]/port-hotels-with-parking.vue")
  },
  {
    name: "IATA-airport-hotels-with-parking___en",
    path: "/:IATA()/airport-hotels-with-parking",
    component: () => import("/codebuild/output/src3975238830/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/[IATA]/airport-hotels-with-parking.vue")
  },
  {
    name: "hotel-package-code-name-IATA___en",
    path: "/hotel-package/:code()-:name()-:IATA()",
    component: () => import("/codebuild/output/src3975238830/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/hotel-package/[code]-[name]-[IATA].vue")
  },
  {
    name: "Guides___en",
    path: "/:IATA([a-z]{3})",
    component: () => import("/codebuild/output/src3975238830/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/[IATA]/guides.vue")
  },
  {
    name: component_45stub26lPXVAan__45OGD6y1aHJsfzNHku7ypekj4o_dHoFicEMeta?.name,
    path: "/sitemap.xml",
    component: component_45stub26lPXVAan__45OGD6y1aHJsfzNHku7ypekj4o_dHoFicE
  }
]